import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBjhudBBAnJQgFMhp8HI61_651fCGiBLq8",
  authDomain: "pps-tools.firebaseapp.com",
  projectId: "pps-tools",
  storageBucket: "pps-tools.firebasestorage.app",
  messagingSenderId: "151613968855",
  appId: "1:151613968855:web:4f21a878ca8db456c0fb92",
  measurementId: "G-XP9L42J4F0"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const signInWithGoogle = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);
        return result.user;
    } catch (error) {
        console.error("Google Sign-In Error:", error);
        throw error;
    }
};
